var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"display":"inline"}},[(_vm.value)?_c('font-awesome-icon',{staticStyle:{"--fa-primary-color":"white"},attrs:{"icon":['fa', 'check'],"size":"lg"}}):_vm._e(),(!_vm.value)?_c('font-awesome-icon',{staticStyle:{"--fa-primary-color":"white"},attrs:{"icon":['fa', 'ban'],"size":"lg"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }